import ProjectsV2 from './projectsV2'
export default ProjectsV2
